export default __webpack_public_path__ + "static/seeis-b8a30870df69270d8fc9ae83782974bd.woff";